module.exports = __webpack_public_path__ + "static/media/EMS.1a2363c6.jpg";